import { useEffect } from "react";

import { getSearch } from "@/api/endpoints/searches";
import { SEARCH_KIND } from "@/constants";
import {
  Empty,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from "@components/ui/empty";
import { Spinner } from "@components/ui/spinner";

const Initializing = ({ alert }) => {
  useEffect(() => {
    let mounted = true;

    if (alert.uuid) {
      (async function () {
        while (mounted) {
          try {
            const { data } = await getSearch(alert.uuid);

            if (data.can_mentions_be_presented) {
              window.location.reload();
            }
          } catch {
            // reload page if the search creation fails
            window.location.reload();
          }
          await new Promise((resolve) => setTimeout(resolve, 10000)); // 10 seconds
        }
      })();
    }
    return () => {
      mounted = false;
    };
  }, [alert.uuid]);

  const isSavedSearch = alert && alert.kind === SEARCH_KIND.SAVED;

  return (
    <Empty data-testid="alert-initializing">
      <EmptyHeader>
        <EmptyMedia variant="icon">
          <Spinner />
        </EmptyMedia>
        <EmptyTitle>
          {isSavedSearch
            ? L.SAVED_SEARCH_MENTIONS_INITIALIZING
            : L.MENTIONS_INITIALIZING}
        </EmptyTitle>
        <EmptyDescription>
          {isSavedSearch
            ? L.SAVED_SEARCH_MENTIONS_INITIALIZING_CREATING
            : L.MENTIONS_INITIALIZING_CREATING}
        </EmptyDescription>
      </EmptyHeader>
    </Empty>
  );
};
export default Initializing;
